// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"260":"5fb30b5b","668":"12ddbd80","762":"825bc8a5"}[chunkId] + ".js";
};